import { Component, Input } from '@angular/core';
import { SponsorCardModel } from '../../../models/sponsor-card.model';

@Component({
  selector: 'app-sponsor-card',
  templateUrl: './sponsor-card.component.html',
  styleUrl: './sponsor-card.component.scss',
  standalone: false,
})
export class SponsorCardComponent {
  @Input() sponsorCards: SponsorCardModel[];

  constructor() {}

  openLink(sponsorCard: SponsorCardModel): void {
    if (sponsorCard.link) {
      window.open(sponsorCard.link, '_blank');
    }
  }
}
